module.exports = __webpack_public_path__ + "static/media/ce200-placeholder.1f7aeb51.png";